var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 682.67 682.67",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 682.67)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.99 393.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.03 5.521c1.102 1.511 1.697 3.333 1.697 5.204v72.362c0 2.341-0.931 4.587-2.586 6.241l-19.052 19.053c-1.655 1.654-3.901 2.585-6.241 2.585h-113.68c-2.341 0-4.586-0.931-6.242-2.585l-19.052-19.053c-1.655-1.654-2.585-3.9-2.585-6.241v-72.362c0-1.871 0.594-3.693 1.697-5.204l33.031-45.264c1.662-2.278 4.311-3.624 7.13-3.624h85.719c2.819 0 5.469 1.346 7.131 3.624l10.153 13.915",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241 349.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-44.209c0-4.639 2.146-9.018 5.814-11.858l20.407-15.809c3.705-2.87 5.918-7.382 5.918-12.069v-8.144c0-11.453-9.319-20.771-20.773-20.771h-12.197c-7.43 0-14.338 4.006-18.029 10.454l-12.269 21.439c-4.115 7.191-13.279 9.684-20.469 5.569-7.191-4.115-9.684-13.279-5.569-20.469l12.27-21.441c9.02-15.761 25.905-25.552 44.066-25.552h12.197c27.996 0 50.773 22.776 50.773 50.771v8.144c0 13.897-6.559 27.275-17.546 35.786l-14.593 11.305v36.854",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.07 427.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-14.949-12.119-27.067-27.067-27.067-14.949 0-27.068 12.118-27.068 27.067 0 14.948 12.119 27.066 27.068 27.066 14.948 0 27.067-12.118 27.067-27.066z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.76 482.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 22.047 22.047",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.05 391.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 21.831 21.831",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.18 504.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-69.894-69.894",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(246.58 350.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 21.367 21.367",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.53 380.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-21.664-21.663",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.8 415.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 28.918 28.918",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.89 488.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-29.31-29.31",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.73 247.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-14.45 8.991c-3.313 2.063-7.523 2.008-10.782-0.138l-171.17-112.73",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.67 143.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-141.45 88.018",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.295 143.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-15.935c-5.635 0-10.203-4.568-10.203-10.203v-15.717h36.342v15.717c0 5.635-4.568 10.203-10.204 10.203z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(430.7 143.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h15.935c5.635 0 10.203-4.568 10.203-10.203v-15.717h-36.342v15.717c0 5.635 4.568 10.203 10.204 10.203z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(366.95 117.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-352.85c-3.825 0-6.925-3.101-6.925-6.926v-15.381c0-3.825 3.1-6.925 6.925-6.925h483.81c3.825 0 6.926 3.1 6.926 6.925v15.381c0 3.825-3.101 6.926-6.926 6.926h-98.999",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.347 36.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-44.254c-3.825 0-6.925-3.101-6.925-6.926v-15.382c0-3.824 3.1-6.925 6.925-6.925h483.81c3.824 0 6.925 3.101 6.925 6.925v15.382c0 3.825-3.101 6.926-6.925 6.926h-407.6",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.428 88.754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-52.222",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(491.57 88.754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-52.222",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.0baa55b804f68ffad09a7e56df5c1161.svg";
export { ForwardRef as ReactComponent };